import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "../theme/AppTheme";
import AppAppBar from "../components/AppAppBar";
import Footer from "../components/Footer";
import EquipmentsSection from "../components/Equipments";
import FloatingSocialButtons from "../components/FloatingSocialButtons";

export default function Equipments(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />

      <AppAppBar />
      <FloatingSocialButtons />
      <div>
        <EquipmentsSection />
        <Footer />
      </div>
    </AppTheme>
  );
}
